export default __webpack_public_path__ + "static/media/cover3.ea825ddf.png";